module.exports = __webpack_public_path__ + "img/523cf04.png";